(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[850],{

/***/ 6945:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paginas/[page]",
      function () {
        return __webpack_require__(3098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Body; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9863);


const Body = (param)=>{
    let { children , ...props } = param;
    const { Body: BodyTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__/* .useComponentsTheme */ .U)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BodyTheme, {
        ...props,
        children: children
    });
};


/***/ }),

/***/ 3098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useSiteSettings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1371);
/* harmony import */ var components_Body__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3405);




const Page = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { pages  } = (0,hooks_useSiteSettings__WEBPACK_IMPORTED_MODULE_2__/* .useSiteSettings */ .h)();
    const currentPage = pages === null || pages === void 0 ? void 0 : pages.find((page)=>page.tag === router.query.page);
    if (!(currentPage === null || currentPage === void 0 ? void 0 : currentPage.html)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Body__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .u, {
        hasSpacingY: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: currentPage.html
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6945); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);